const breakpoints = ["320px", "672px", "1024px", "1312px", "1584px"];

/** Aliases */
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xlg = breakpoints[3];
breakpoints.max = breakpoints[4];

export default breakpoints;
